export default "__VITE_ASSET__v5wWwE$X__"